import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Helmet  from 'react-helmet';
import DownloadIcon from '@mui/icons-material/Download';
const ResumePublic = () => {
  const API_BASE_URL =
    process.env.NODE_ENV === 'production'
      ? process.env.REACT_APP_API_URL_PRODUCTION
      : process.env.REACT_APP_API_URL;

  const [resume, setResume] = useState(null);
  const [darkMode, setDarkMode] = useState(true);
  const [showModal, setShowModal] = useState(false); // ✅ modal toggle

  useEffect(() => {
    const fetchResume = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/api/resume`);
        setResume(res.data);
      } catch (err) {
        console.error('Failed to load resume', err);
      }
    };
    fetchResume();
  }, []);

  if (!resume) return <div className="resume-public">Loading...</div>;

  return (
    <div className={`resume-public ${darkMode ? 'dark' : 'light'}`}>
      <Helmet>
        <title>NavarroJalen | Resume</title>
        <meta name="description" content="NavarroJalen | Resume" />
        <meta property="og:title" content="NavarroJalen | Resume" />
      </Helmet>
      {/* Toggle Button */}
      <button className="theme-toggle" onClick={() => setDarkMode(!darkMode)}>
        {darkMode ? '🌙 Dark' : '☀️ Light'}
      </button>

      {/* ✅ Modal */}
      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <img src={resume.avatarUrl} alt="avatar enlarged" className="modal-avatar" />
          </div>
        </div>
      )}

      <header className="resume-header">
        {resume.avatarUrl && (
          <img
            src={resume.avatarUrl}
            alt="avatar"
            className="avatar"
            onClick={() => setShowModal(true)}
            style={{ cursor: 'pointer' }}
          />
        )}
        <div className="header-info">
          <h1>{resume.name}</h1>
          <h2>{resume.title}</h2>
        </div>
        {resume.logoUrl && (
          <img src={resume.logoUrl} alt="Logo" className="resume-logo-inline" />
        )}
      </header>

      {/* ...rest of resume content... */}
      <section className="resume-summary">
        <h3>About Me</h3>
        <p>{resume.summary}</p>
      </section>

      <section className="resume-skills">
        <h3>Skills</h3>
        <ul>
          {(resume.skills || []).map((skill, i) => (
            <li key={i}>{skill}</li>
          ))}
        </ul>
      </section>

      <section className="resume-experience">
        <h3>Experience</h3>
        {(resume.experience || []).map((exp, i) => (
          <div key={i} className="experience-item">
            <strong>{exp.position}</strong> at <em>{exp.company}</em>
            <div>{exp.period}</div>
            <p>{exp.description}</p>
          </div>
        ))}
      </section>

      <section className="resume-education">
        <h3>Education</h3>
        {(resume.education || []).map((edu, i) => (
          <div key={i}>
            <strong>{edu.degree}</strong>, {edu.institution}
            <div>{edu.year}</div>
          </div>
        ))}
      </section>

      <section className="resume-projects">
        <h3>Projects</h3>
        {(resume.projects || []).map((proj, i) => (
          <div key={i} className='public-resume-desc'> 
            <a href={proj.link} target="_blank" rel="noreferrer">
              <strong>{proj.name}</strong>
            </a>
            <p>{proj.description}</p>
          </div>
        ))}
      </section>

      <footer className="resume-footer">
        <h3>Contact</h3>
        <div className="social-links">
          {resume.contact?.phone && <span>{resume.contact.phone}</span>}
          {resume.contact?.email && <span>{resume.contact.email}</span>}
          {resume.contact?.location && <span>{resume.contact.location}</span>}
        </div>
      </footer>


     {/* {resume.resumeLink && (
        <a
  href={resume.resumeLink}
  target="_blank"
  rel="noopener noreferrer"
  className="floating-resume-download"
  title="Download Resume"
>
  <DownloadIcon />
</a> */}
    {/* )} */}



    </div>
  );
};

export default ResumePublic;
